import { AxiosResponse } from "axios";

import API from "../api";

import { Message } from "../models/video.survey.message";

const ROUTE_NAME = "videosurvey/rooms/messages";

const VideoSurveyMessageService = {
  async getAll(options?: any): Promise<AxiosResponse<any>> {
    return await API.get(`/${ROUTE_NAME}`, { params: options });
  },
  async create(message: Message): Promise<AxiosResponse<any>> {
    return await API.post(`/${ROUTE_NAME}`, message);
  },
};

export default VideoSurveyMessageService;
